// Shared math constants.

export const PI = Math.PI;
